export default [
  {
    path: '/home',
    name: 'home',
    component: () => import('./Home.vue'),
    meta: {
      requiresAuth: true,
      name: 'Home',
    },
  },
]
